import React from "react";
import Layout from "../components/layout";
import Seo from "../components/seo";
import HeaderAd from "../components/ads/header-ad";

// markup
const HistoryPage = () => {
  return (
    <Layout>
      <Seo title={`Online Hangman`} />
      <div>
        <HeaderAd />
      </div>
      <div className={"container mx-auto px-4 pb-6 py-6"}>
        <h1 className={"text-4xl font-bold mb-10"}>History of Word Games</h1>
        <div className={"w-full p-4  bg-white"}>
          <p>History of word games coming soon.</p>
        </div>
      </div>
    </Layout>
  );
};

export default HistoryPage;
